import { useState } from 'react'
import './App.css'
import { Block } from './components/block'
import { Box } from '@chakra-ui/react'
import { AccountProvider } from './components/ui/account-context';
import { ChatbotProvider } from './components/ui/chatbot-context';
import { AuthProvider } from './components/ui/auth-context';

function App() {
    const [fontFamily, setFontFamily] = useState('Proxima Nova');

    const handleFontChange = (e: any) => {
        //console.log(e.target.id);
        e.stopPropagation();
        setFontFamily(e.target.id);
    }

    return (
        <AuthProvider>
            <AccountProvider>
                <ChatbotProvider>
                    <Box>
                        {/* <Box color={'black'} ><nys-unavheader hideSearch></nys-unavheader></Box> */}
                        <Block fontFamily={fontFamily} setFontFamily={handleFontChange} />
                    </Box>
                </ChatbotProvider>
            </AccountProvider>
        </AuthProvider>
    )
}

export default App
